@if (!fullRecordOptions) {
  <h3>Unable to Load FullRecord Tab Configuration</h3>
} @else {
  <form
    [formGroup]="fullRecordForm"
    (ngSubmit)="saveFullRecordOptions(fullRecordForm.getRawValue())"
  >
    <h3 class="text-center">Full Record</h3>
    <div class="padding-0-25">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
        <mat-tab label="Staff">
          <div class="padding-35-0" fxLayout="column" fxLayoutAlign="center stretch">
            <h4 fxLayoutAlign="space-around center">Default Section</h4>
            <mat-form-field appearance="outline">
              <mat-select formControlName="staffDefaultTabId">
                @for (tab of tabs; track tab) {
                  <mat-option [value]="tab.id">{{ tab.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (fullRecordForm?.errors) {
              <strong class="red staffSelectDropdownError">{{
                fullRecordForm.errors.staffSelectDropdownError
              }}</strong>
            }
            <br />
            <h4 fxLayoutAlign="space-around center">Section Configuration</h4>
            <label for="descriptionDetailsStaff">{{ fullRecordOptions.detailTab.name }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                placeholder="Enter a label"
                formControlName="staffDetailLabel"
                maxlength="30"
              />
              <mat-hint align="end"
                >{{ fullRecordForm.get('staffDetailLabel').value.length || 0 }}/30</mat-hint
              >
            </mat-form-field>
            <label for="descriptionWhereStaff">{{ fullRecordOptions.whereTab.name }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                placeholder="Enter a label"
                title="Where to Find it"
                formControlName="staffWhereLabel"
                maxlength="30"
              />
              <mat-hint align="end"
                >{{ fullRecordForm.get('staffWhereLabel').value.length || 0 }}/30</mat-hint
              >
            </mat-form-field>
            @if (fullRecordOptions.displayMARC) {
              <mat-checkbox
                formControlName="staffDisplayMARC"
                (change)="toggleFormControl('staffMARCLabel')"
                >Display MARC</mat-checkbox
              >
            }
            <mat-form-field appearance="outline">
              <input
                matInput
                placeholder="Enter a label"
                title="MARC Record"
                formControlName="staffMARCLabel"
                maxlength="30"
              />
              <mat-hint align="end"
                >{{ fullRecordForm.get('staffMARCLabel').value.length || 0 }}/30</mat-hint
              >
            </mat-form-field>
            @if (fullRecordOptions.moreAboutThisTitleTab) {
              @if (fullRecordOptions.displayMoreAboutThisTitle) {
                <mat-checkbox
                  formControlName="staffDisplayMoreAboutThisTitle"
                  (change)="toggleFormControl('staffMoreAboutThisTitleLabel')"
                  >Display More About This</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="More About Title"
                  formControlName="staffMoreAboutThisTitleLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{
                    fullRecordForm.get('staffMoreAboutThisTitleLabel').value.length || 0
                  }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (fullRecordOptions.displayGoodreadsReview) {
              <mat-checkbox formControlName="staffDisplayGoodreadsReview"
                >Display Goodreads® Reviews</mat-checkbox
              >
            }
            <mat-form-field appearance="outline">
              <input
                matInput
                placeholder="Enter a label"
                title="Goodreads® Reviews"
                formControlName="staffGoodreadsReviewLabel"
              />
            </mat-form-field>
            @if (fullRecordOptions.syndeticsUnboundTab) {
              @if (fullRecordOptions.displaySyndeticsUnbound) {
                <mat-checkbox
                  formControlName="staffDisplaySyndeticsUnbound"
                  (change)="toggleFormControl('staffSyndeticsUnboundLabel')"
                  >Display Syndetics Unbound</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="Syndetics Unbound"
                  formControlName="staffSyndeticsUnboundLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{
                    fullRecordForm.get('staffSyndeticsUnboundLabel').value.length || 0
                  }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (fullRecordOptions.novelistTab) {
              @if (fullRecordOptions.displayNovelist) {
                <mat-checkbox
                  formControlName="staffDisplayNovelist"
                  (change)="toggleFormControl('staffNovelistLabel')"
                  >Display Novelist</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="Novelist"
                  formControlName="staffNovelistLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{ fullRecordForm.get('staffNovelistLabel').value.length || 0 }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (fullRecordOptions.clcdTab) {
              @if (fullRecordOptions.displayCLCD) {
                <mat-checkbox
                  formControlName="staffDisplayCLCD"
                  (change)="toggleFormControl('staffCLCDLabel')"
                  >Display {{ fullRecordOptions.clcdTab.name }}</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="staffCLCDLabel"
                  [attr.title]="fullRecordOptions.clcdTab.name"
                  maxlength="30"
                  placeholder="Enter a label"
                />
                <mat-hint align="end"
                  >{{ fullRecordForm.get('staffCLCDLabel').value.length || 0 }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (fullRecordOptions.shelfBrowseTab) {
              @if (fullRecordOptions.displayShelfBrowse) {
                <mat-checkbox
                  formControlName="staffDisplayShelfBrowse"
                  (change)="toggleFormControl('staffShelfBrowseLabel')"
                  >Display Shelf Browse</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="Shelf Browse"
                  formControlName="staffShelfBrowseLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{ fullRecordForm.get('staffShelfBrowseLabel').value.length || 0 }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (canShowILLLenderColumn) {
              <label for="descrLenderColumn">ILL Lender Column Label</label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="ILL Lender Column Label"
                  formControlName="lenderColumnLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{ fullRecordForm.get('lenderColumnLabel').value.length || 0 }}/30</mat-hint
                >
              </mat-form-field>
              <label for="descrLenderContents">ILL Lender Contents Label</label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="ILL Lender Contents Label"
                  formControlName="lenderContentsLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{ fullRecordForm.get('lenderContentsLabel').value.length || 0 }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (fullRecordOptions.displayCopyCataloging) {
              <mat-checkbox formControlName="copyCatalogForStaff"
                >Display Copy Cataloging</mat-checkbox
              >
            }
          </div>
        </mat-tab>
        <mat-tab label="Patron/Guest">
          <div class="padding-35-0" fxLayout="column" fxLayoutAlign="center stretch">
            <h4 fxLayoutAlign="space-around center">Default Section</h4>
            <mat-form-field appearance="outline">
              <mat-select formControlName="patronGuestDefaultTabId">
                @for (tab of tabs; track tab) {
                  <mat-option [value]="tab.id">{{ tab.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (fullRecordForm?.errors) {
              <strong class="red patronGuestSelectDropdownError">{{
                fullRecordForm.errors.patronGuestSelectDropdownError
              }}</strong>
            }
            <br />
            <h4 fxLayoutAlign="space-around center">Section Configuration</h4>
            <label for="descriptionDetailsPatronGuest">{{
              fullRecordOptions.detailTab.name
            }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                formControlName="patronGuestDetailLabel"
                placeholder="Enter a label"
                [placeholder]="fullRecordOptions.detailTab.name"
              />
              <mat-hint align="end"
                >{{ fullRecordForm.get('patronGuestDetailLabel').value.length || 0 }}/30</mat-hint
              >
            </mat-form-field>
            <label for="descriptionWherePatronGuest">{{ fullRecordOptions.whereTab.name }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                formControlName="patronGuestWhereLabel"
                placeholder="Enter a label"
                title="Where to Find it"
                maxlength="30"
              />
              <mat-hint align="end"
                >{{ fullRecordForm.get('patronGuestWhereLabel').value.length || 0 }}/30</mat-hint
              >
            </mat-form-field>
            @if (fullRecordOptions.displayMARC) {
              <mat-checkbox
                formControlName="patronGuestDisplayMARC"
                (change)="toggleFormControl('patronGuestMARCLabel')"
                >Display MARC</mat-checkbox
              >
            }
            <mat-form-field appearance="outline">
              <input
                matInput
                placeholder="Enter a label"
                title="MARC Record"
                formControlName="patronGuestMARCLabel"
                maxlength="30"
              />
              <mat-hint align="end"
                >{{ fullRecordForm.get('patronGuestMARCLabel').value.length || 0 }}/30</mat-hint
              >
            </mat-form-field>
            @if (fullRecordOptions.moreAboutThisTitleTab) {
              @if (fullRecordOptions.displayMoreAboutThisTitle) {
                <mat-checkbox
                  formControlName="patronGuestDisplayMoreAboutThisTitle"
                  (change)="toggleFormControl('patronGuestMoreAboutThisTitleLabel')"
                  >Display More About This</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="More About Title"
                  formControlName="patronGuestMoreAboutThisTitleLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{
                    fullRecordForm.get('patronGuestMoreAboutThisTitleLabel').value.length || 0
                  }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (fullRecordOptions.displayGoodreadsReview) {
              <mat-checkbox formControlName="patronGuestDisplayGoodreadsReview"
                >Display Goodreads® Reviews</mat-checkbox
              >
            }
            <mat-form-field appearance="outline">
              <input
                matInput
                placeholder="Enter a label"
                title="Goodreads® Reviews"
                formControlName="patronGuestGoodreadsReviewLabel"
              />
            </mat-form-field>
            @if (fullRecordOptions.syndeticsUnboundTab) {
              @if (fullRecordOptions.displaySyndeticsUnbound) {
                <mat-checkbox
                  formControlName="patronGuestDisplaySyndeticsUnbound"
                  (change)="toggleFormControl('patronGuestSyndeticsUnboundLabel')"
                  >Display Syndetics Unbound</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="Syndetics Unbound"
                  formControlName="patronGuestSyndeticsUnboundLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{
                    fullRecordForm.get('patronGuestSyndeticsUnboundLabel').value.length || 0
                  }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (fullRecordOptions.novelistTab) {
              @if (fullRecordOptions.displayNovelist) {
                <mat-checkbox
                  formControlName="patronGuestDisplayNovelist"
                  (change)="toggleFormControl('patronGuestNovelistLabel')"
                  >Display Novelist</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="Novelist"
                  formControlName="patronGuestNovelistLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{
                    fullRecordForm.get('patronGuestNovelistLabel').value.length || 0
                  }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (fullRecordOptions.clcdTab) {
              @if (fullRecordOptions.displayCLCD) {
                <mat-checkbox
                  formControlName="patronGuestDisplayCLCD"
                  (change)="toggleFormControl('patronGuestCLCDLabel')"
                  >Display {{ fullRecordOptions.clcdTab.name }}</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="patronGuestCLCDLabel"
                  [attr.title]="fullRecordOptions.clcdTab.name"
                  maxlength="30"
                  placeholder="Enter a label"
                />
                <mat-hint align="end"
                  >{{ fullRecordForm.get('patronGuestCLCDLabel').value.length || 0 }}/30</mat-hint
                >
              </mat-form-field>
            }
            @if (fullRecordOptions.shelfBrowseTab) {
              @if (fullRecordOptions.displayShelfBrowse) {
                <mat-checkbox
                  formControlName="patronGuestDisplayShelfBrowse"
                  (change)="toggleFormControl('patronGuestShelfBrowseLabel')"
                  >Display Shelf Browse</mat-checkbox
                >
              }
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Enter a label"
                  title="Shelf Browse"
                  formControlName="patronGuestShelfBrowseLabel"
                  maxlength="30"
                />
                <mat-hint align="end"
                  >{{
                    fullRecordForm.get('patronGuestShelfBrowseLabel').value.length || 0
                  }}/30</mat-hint
                >
              </mat-form-field>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="padding-25" fxLayout="row" fxLayoutAlign="end none">
      <button
        mat-stroked-button
        role="button"
        aria-label="Save"
        type="submit"
        [disabled]="fullRecordForm.invalid"
      >
        Save
      </button>
    </div>
  </form>
}
